"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorMessageSelector = exports.isDeletingSelector = exports.isDeleteUserDialogOpenSelector = exports.userToBeDeletedSelector = exports.saveChangesSuccessSelector = exports.usersToastStatusSelector = exports.userToBeEditedSelector = exports.isEditUserModalOpenSelector = exports.isCreateUserModalOpenSelector = exports.hasErrorSavingUserSelector = exports.isSavingUserSelector = exports.userSavedSuccessSelector = exports.filteredUsersSelector = exports.areUsersLoadingSelector = exports.usersSelector = void 0;
const usersSelector = (state) => {
    return state.users.users.map((user) => {
        return {
            id: user.id,
            username: user.username,
            email: user.email,
            roles: user.roles,
            department: user.department,
        };
    });
};
exports.usersSelector = usersSelector;
const areUsersLoadingSelector = (state) => {
    return state.users.areUsersLoading;
};
exports.areUsersLoadingSelector = areUsersLoadingSelector;
const filteredUsersSelector = (state) => {
    return state.users.filteredUsers.map((user) => {
        return {
            id: user.id,
            username: user.username,
            email: user.email,
            roles: user.roles,
            department: user.department,
        };
    });
};
exports.filteredUsersSelector = filteredUsersSelector;
const userSavedSuccessSelector = (state) => {
    return state.users.changesSavedSuccess;
};
exports.userSavedSuccessSelector = userSavedSuccessSelector;
const isSavingUserSelector = (state) => {
    return state.users.isSavingChanges;
};
exports.isSavingUserSelector = isSavingUserSelector;
const hasErrorSavingUserSelector = (state) => {
    return state.users.hasErrorSavingChanges;
};
exports.hasErrorSavingUserSelector = hasErrorSavingUserSelector;
const isCreateUserModalOpenSelector = (state) => {
    return state.users.isCreateUserModalOpen;
};
exports.isCreateUserModalOpenSelector = isCreateUserModalOpenSelector;
const isEditUserModalOpenSelector = (state) => {
    return state.users.isEditUserModalOpen;
};
exports.isEditUserModalOpenSelector = isEditUserModalOpenSelector;
const userToBeEditedSelector = (state) => {
    return state.users.userToBeEdited;
};
exports.userToBeEditedSelector = userToBeEditedSelector;
const usersToastStatusSelector = (state) => {
    return state.users.usersToastStatus;
};
exports.usersToastStatusSelector = usersToastStatusSelector;
const saveChangesSuccessSelector = (state) => {
    return state.users.changesSavedSuccess;
};
exports.saveChangesSuccessSelector = saveChangesSuccessSelector;
const userToBeDeletedSelector = (state) => {
    return state.users.userToBeDeleted;
};
exports.userToBeDeletedSelector = userToBeDeletedSelector;
const isDeleteUserDialogOpenSelector = (state) => {
    return state.users.isDeleteAlertDialogOpen;
};
exports.isDeleteUserDialogOpenSelector = isDeleteUserDialogOpenSelector;
const isDeletingSelector = (state) => {
    return state.users.isDeleting;
};
exports.isDeletingSelector = isDeletingSelector;
const errorMessageSelector = (state) => {
    return state.users.errorMessage;
};
exports.errorMessageSelector = errorMessageSelector;
